import { Recurso } from "lib.common/dist/CleanArch";
import { ErrDevValidacion } from 'lib.common/dist/errorHandler';
import { ProductosRepository } from "../../bussines/repository/ProductosRepository";
import { Producto } from "../../bussines/entities/Productos.entity";
import { ProductosDtSource } from "../../bussines/dataSources/ProductosDtSource";
import { ProductoModel } from "../models/ProductoModel ";

export class ProductosRepositoryImpl implements ProductosRepository<Producto> {
    private dataSource: ProductosDtSource;

    constructor(dataSource: ProductosDtSource) {
        this.dataSource = dataSource;
    }

    async getAllProductos(): Promise<Recurso<Producto[]>> {
        try {
            const result = await this.dataSource.getAllProductos();

            if (result.isSuccess()) {
                return Recurso.fromData<Producto[]>(
                    result.data!.map(ProductoModel.deserialize)
                );
            }
            return Recurso.fromError<Producto[]>(result.error!);
        } catch (error) {
            return Recurso.fromError<Producto[]>(
                new ErrDevValidacion(error as Error)
            );
        }
    }
    
}